import React from 'react';
import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import storage from 'redux-persist/lib/storage'; // Use localStorage as the default storage
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import allReducer from './reducer/index';
import localforage from 'localforage';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

// Configure localForage
const localForageStore = localforage.createInstance({
  name: 'MyAppDatabase',
  storeName: 'epg', // Table name in IndexedDB
});

// Redux Persist Configuration
const persistConfig = {
  key: 'root',
  storage: localforage, // Use localForage instead of localStorage
  stateReconciler: autoMergeLevel2, // Two levels deep
};

const persistedReducer = persistReducer(persistConfig, allReducer);

const indexedDBMiddleware = store => next => async action => {
  // Automatically load cached data for pending actions
  if (action.type.endsWith('/pending')) {
    const cachedData = await localForageStore.getItem(action.type.replace('/pending', '/fulfilled'));
    if (cachedData) {
      return store.dispatch({
        type: action.type.replace('/pending', '/fulfilled'),
        payload: cachedData,
        meta: action.meta,
      });
    }
  }

  const result = await next(action);

  // Automatically save data for fulfilled actions
  if (action.type.endsWith('/fulfilled')) {
    await localForageStore.setItem(action.type, action.payload);
  }

  return result;
};

// Configure the Redux store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable serializability check for Redux-Persist
    }).concat(indexedDBMiddleware),
  devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store);

// Rendering the App
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      {/* PersistGate delays rendering until persistence is complete */}
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();
